module.exports = __webpack_public_path__ + "img/expertise_area_logo.9de78546.svg";